/**
 * Created by Ma jerez on 15/07/2016.
 */

import LatLngBounds = google.maps.LatLngBounds;
import GMap = google.maps.Map;
import MapOptions = google.maps.MapOptions;
import LatLng = google.maps.LatLng;
import Marker = google.maps.Marker;
import Prediction = google.maps.places.AutocompletePrediction;
import PlacesService = google.maps.places.PlacesService;
import PlaceResult = google.maps.places.PlaceResult;
import PSStatus = google.maps.places.PlacesServiceStatus;
import PlaceSearchPagination = google.maps.places.PlaceSearchPagination;
import Animation = google.maps.Animation;
import Autocomplete = google.maps.places.Autocomplete;
import Geocoder = google.maps.Geocoder;
import GeocoderResult = google.maps.GeocoderResult;
import GeocoderStatus = google.maps.GeocoderStatus;
import InfoWindow = google.maps.InfoWindow;
import {markerWraper} from "./markerWrapper";
declare const window:any;

declare const jQuery:any;

declare const GEO_JSON;
declare const COUNTRY:string;
var mapTypeStyle: google.maps.MapTypeStyle = {
	elementType:'geometry',
	stylers:[
		{
			hue:'#ff4400'
		},
		{
			saturation:-68
		},
		{
			lightness:-4
		},
		{
			gamma:0.72
		}
	]
}
var mapTypeFeature1: google.maps.MapTypeStyle =	{
	featureType:'road' ,
	elementType:'labels.icon'
}
var mapTypeFeature2: google.maps.MapTypeStyle ={
	featureType:'landscape.man_made',
	elementType:'geometry',
	stylers:[
		{
			hue:'#0077ff'
		},
		{
			gamma:3.1
		}
	]
}
var mapTypeFeature3: google.maps.MapTypeStyle =	{
	featureType:'water',
	stylers:[
		{hue:'#00ccff'},
		{gamma:0.44},{saturation:-33}
	]
}
var mapTypeFeature4: google.maps.MapTypeStyle =	{
	featureType:'poi.park',
	stylers:[
		{hue:'#44ff00'},
		{saturation:-23}
	]
}
var mapTypeFeature5: google.maps.MapTypeStyle = 	{
	featureType:'water',
	elementType:'labels.text.fill',
	stylers:[
		{hue:'#007fff'},
		{gamma:0.77},
		{saturation:65},
		{lightness:99}
	]
}
var mapTypeFeature6: google.maps.MapTypeStyle =
{
	featureType:'water',
	elementType:'labels.text.stroke',
	stylers:[
		{gamma:0.11},
		{'weight':5.6},
		{saturation:99},
		{hue:'#0091ff'},
		{lightness:-86}
	]
}

var mapTypeFeature7: google.maps.MapTypeStyle = {
	featureType:'transit.line',
	elementType:'geometry',
	stylers:[
		{lightness:-48},
		{hue:'#ff5e00'},
		{gamma:1.2},
		{saturation:-23}
	]
}

var mapTypeFeature8: google.maps.MapTypeStyle = {
	featureType:'transit',
	elementType:'labels.text.stroke',
	stylers:[
		{saturation:-64},
		{hue:'#ff9100'},
		{lightness:16},
		{gamma:0.47},
		{weight:2.7}
	]
}
var mapStyle = [
	mapTypeStyle,
	mapTypeFeature1,
	mapTypeFeature2,
	mapTypeFeature3,
	mapTypeFeature4,
	mapTypeFeature5,
	mapTypeFeature6,
	mapTypeFeature7,
	mapTypeFeature8
]


export class storesMap {



	//disply or fide component
	active = false;

	//city and activity text
	city = "none";
	activity = "none";


	//map congig
	radius = 500;
	country = "ireland";
	center:LatLng;
	mapConf:MapOptions;
	places:PlacesService;
	geocoder:Geocoder;
	$document:JQuery<Document>;
	$notifyhack:JQuery;
	irelanBounds:LatLngBounds;
	map:GMap;


	markers:markerWraper[]=[];


	/**
	 * nearBy markers
	 * @param suggestedAreasService
	 */

	constructor() {

		this.center = new LatLng(ireland.geometry.location.lat, ireland.geometry.location.lng);
		let sw = new LatLng(ireland.geometry.viewport.southwest.lat, ireland.geometry.viewport.southwest.lng);
		let ne = new LatLng(ireland.geometry.viewport.northeast.lat, ireland.geometry.viewport.northeast.lng);
		this.mapConf = {
			zoom: ireland.zoom,
			center: this.center,
			streetViewControl: false,
			mapTypeControl: false,
			scrollwheel:false,
			styles: mapStyle,
			zoomControlOptions: {
				position: google.maps.ControlPosition.LEFT_CENTER,
			},
		};
		this.irelanBounds = new LatLngBounds(sw, ne);
		this.$document = jQuery(document);
	    this.initMap();
        this.hideBtn();
		this.initMarkers();
		this.showNav();
		/* REMOVED BECAUSE MISSING .co.uk site */
		// if(typeof(COUNTRY) !== 'undefined'){
		// 	if (COUNTRY == "IE") {
		// 		this.addNIOverlay();
		// 	} else {
		// 		this.addIEOverlay();
		// 	}
		// }
	}


	hideBtn(){
		jQuery(".hideNav").click(function(){
			jQuery(".storeNav").toggleClass("active");
		})
	}


	showNav(){
		setTimeout(()=>{
			jQuery(".storeNav").addClass("active");
		},500);
	}


	/**
	 * Initializes th google maps
	 * @param conf
	 */
	initMap() {
		this.map = new GMap(document.getElementById('places-map'), this.mapConf);
	}

	/**
	 * Forzes a map rerender (this causes the map to not render properly)
	 */
	forzeReDraw(){
		setTimeout(()=> {
			google.maps.event.trigger(this.map, 'resize');
			this.map.setZoom(this.map.getZoom());
			jQuery(window).trigger('resize');
		}, 500)
	}


	initMarkers(){
		let list = window.STORELIST;
		//console.log(list)
		if(list){
			for (var key in list) {
				let store =  list[key];
				let marker = new markerWraper(store,this.map);
				this.markers.push(marker);
			}
			//this.fitBoundsToVisibleMarkers();
		}
	}

	fitBoundsToVisibleMarkers() {

		var bounds = new google.maps.LatLngBounds();

		for (var i=0; i<this.markers.length; i++) {
			if(this.markers[i].getPosition()) {
				bounds.extend( this.markers[i].getPosition() );
			}
		}

		this.map.fitBounds(bounds);

	}


	addNIOverlay(){
		this.map.data.loadGeoJson(GEO_JSON.NI);
		this.setGeoStyles("NI");
		this.map.data.addListener('click', (event)=> {
			window.open(this.getStoreLink("NI"),"_self");
		});
	}

	addIEOverlay(){
		this.map.data.loadGeoJson(GEO_JSON.IE);
		this.setGeoStyles("IE");
		this.map.data.addListener('click', (event)=> {
			window.open(this.getStoreLink("IE"),"_self");
		});
	}

	private setGeoStyles(messageClass){
		this.map.data.setStyle({
			fillOpacity:0.2,
			strokeOpacity:0.2
		});

		this.map.data.addListener('mouseover', function(event) {
			this.map.data.setStyle({
				fillOpacity:0.4,
				strokeOpacity:0.4
			});
			jQuery(".g-map-message."+messageClass).addClass("active");
		});
		this.map.data.addListener('mouseout', function(event) {
			this.map.data.setStyle({
				fillOpacity:0.2,
				strokeOpacity:0.2
			});
			jQuery(".g-map-message."+messageClass).removeClass("active");
		});
	}


	/**
	 * Return the store's page link of the  country.
	 *
	 * @param currentCountry
	 */
	private getStoreLink(currentCountry):string{
		var domainName = location.hostname.replace(".ie","").replace(".co.uk","");

		if(currentCountry == "IE"){
			return location.protocol+"//"+domainName+".ie/"+location.pathname+location.search+location.hash;
		}else{
			return location.protocol+"//"+domainName+".co.uk/"+location.pathname+location.search+location.hash;
		}
	}

}


const ireland = {
	formatted_address: "Ireland",
	geometry: {
		location: {
			lat: 53.5148548,
			lng: -5.8090025
		},
		viewport: {
			northeast: {
				lat: 55.4351345,
				lng: -5.99471
			},
			southwest: {
				lat: 51.4199312,
				lng: -10.6694501
			}
		}
	},
	zoom: 8,
	icon: "https://maps.gstatic.com/mapfiles/place_api/icons/geocode-71.png",
	id: "37b02da1a0d679edd3aa38daf22c3f932f674244",
	name: "Ireland",
	place_id: "ChIJ-ydAXOS6WUgRCPTbzjQSfM8",
	types: [
		"country",
		"political"
	]
};


class Route {
	constructor(public place:string, public activity:string, public place_id:string) {
	}
}


function toRadians(deg) {
	return deg * Math.PI / 180;
};

/**
 * Return the distance betwen two points  in meters
 * @param pA
 * @param pB
 * @returns {number}
 */
function distanceTo(pA:LatLng, pB:LatLng):number {


	var R = 6371000;// Earth radius metres
	var phi1 = toRadians(pA.lat()), lambda1 = toRadians(pA.lng());
	var phi2 = toRadians(pB.lat()), lambda2 = toRadians(pB.lng());
	var Deltaphi = phi2 - phi1;
	var Deltalambda = lambda2 - lambda1;

	var a = Math.sin(Deltaphi / 2) * Math.sin(Deltaphi / 2)
		+ Math.cos(phi1) * Math.cos(phi2)
		* Math.sin(Deltalambda / 2) * Math.sin(Deltalambda / 2);
	var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	var d = R * c;

	return d;
};



function replaceAll(target, search, replacement) {
	return target.split(search).join(replacement);
};




